export const BaseLineSub = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.37681 20.6851C5.65796 21.0568 4.80078 20.535 4.80078 19.7258V4.4C4.80078 3.90294 5.20372 3.5 5.70078 3.5H18.3008C18.7979 3.5 19.2008 3.90294 19.2008 4.4V19.7258C19.2008 20.535 18.3436 21.0568 17.6248 20.6851L12.0008 17.7773L6.37681 20.6851Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.9775 7.97998V13.38"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9.27734 10.6802H14.6773"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
